import { useContext, useEffect, useState } from "react";
import { UserContex } from "../components/App2";
// import instnace of axios
import cookieJs from "js-cookie";

export const useCheckCookie = () => {
  const {  dispatch } = useContext(UserContex);
  const [hasCookie, setHasCookie] = useState(false);
  const [error, setError] = useState("");
  const [go, setGo] = useState(false); // loadding

  useEffect(() => {
    async function checkCookie() {
      try {
        const cookie = cookieJs.get("furniture_shop");
        setGo(true);
        if (cookie !== undefined) {
          setHasCookie(cookie);
          dispatch({ type: "USER", payload: true });
        }
        if (error) {
          setError(error);
        }
      } catch (err) {
        setError(err);
        if (error) {
          setError(error);
        }
        setGo(true);
        dispatch({ type: "USER", payload: false });
      }
    }
    checkCookie();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    hasCookie,
    error,
    go,
  };
};
